import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { IConfigurationService } from '../../../services';

class TasksNavigationController implements angular.IComponentController {
    hasExperimentalFeatures: boolean;

    static $inject = [
        'configurationService'
    ];

    constructor(
        private _configurationService: IConfigurationService
    ) {
    }

    $onInit() {
        this.hasExperimentalFeatures = this._configurationService.configuration.useExperimentalFeatures;
    }
}

export const wtTasksNavigation: ComponentDefinition = {
    componentId: 'wtTasksNavigation',
    controller: TasksNavigationController,
    template: require('./tasksNavigation.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};